/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGTextareaWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type RemovableItem_organization$ref: FragmentReference;
declare export opaque type RemovableItem_organization$fragmentType: RemovableItem_organization$ref;
export type RemovableItem_organization = {|
  +databaseId: string,
  +$fragmentRefs: WYSIWYGTextareaWithFeatureFlag_organization$ref,
  +$refType: RemovableItem_organization$ref,
|};
export type RemovableItem_organization$data = RemovableItem_organization;
export type RemovableItem_organization$key = {
  +$data?: RemovableItem_organization$data,
  +$fragmentRefs: RemovableItem_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemovableItem_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGTextareaWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '833be14a00f6f762f040265328a2dafa';

module.exports = node;
